import crud from "./_crud";

const actions = crud('distribution_center', 'la distribución del centro de costo', 'las distribuciones del centro de costo');

export default actions